import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import aboutImg from '../../images/vaya.jpg';
import './About.css';
import { MyButton } from '../../Styles/Styles';

const About = () => {
    return (
        <Box sx={{ p: { xs: 1, sm: 2, md: 5 }, pb: 15, borderRadius: '10px' }} component={Paper} elevation={5}>
            <Grid container spacing={4}>


                <Grid item xs={12} md={6}>

                    <Box sx={{ position: { xs: 'static', md: 'relative' }, width: { xs: '100%', md: '350px' } }}>

                        <img src={aboutImg} className='aboutImg' alt="" />

                        <Box sx={{ backgroundColor: 'primary.main', position: { xs: 'static', md: 'absolute' }, top: { xs: 0, md: '60px' }, right: { xs: 0, md: '-65%' }, width: { xs: '100%', md: '300px' }, borderRadius: '10px', p: 0 }}>

                            <Box sx={{p: 5}}>

                                <Box sx={{ borderBottom: '1px dashed #fff', pb: 1 }}>
                                    <Typography variant='h6' sx={{ fontSize: '13px', color: '#ddd' }}>Name</Typography>
                                    <Typography variant='h4' sx={{ fontSize: '16px', color: '#fff', mt: 1 }}>Sakib Ahmed Saron</Typography>
                                </Box>
                                <Box sx={{ borderBottom: '1px dashed #fff', py: 1 }}>
                                    <Typography variant='h6' sx={{ fontSize: '13px', color: '#ddd' }}>Birthday</Typography>
                                    <Typography variant='h4' sx={{ fontSize: '16px', color: '#fff', mt: 1 }}>April 22, 1990</Typography>
                                </Box>
                                <Box sx={{ borderBottom: '1px dashed #fff', py: 1 }}>
                                    <Typography variant='h6' sx={{ fontSize: '13px', color: '#ddd' }}>Mail</Typography>
                                    <Typography variant='h4' sx={{ fontSize: '16px', color: '#fff', mt: 1 }}>vaya@gmail.com</Typography>
                                </Box>
                                <Box sx={{ borderBottom: '1px dashed #fff', py: 1 }}>
                                    <Typography variant='h6' sx={{ fontSize: '13px', color: '#ddd' }}>Phone</Typography>
                                    <Typography variant='h4' sx={{ fontSize: '16px', color: '#fff', mt: 1 }}>01545465454</Typography>
                                </Box>
                                <Box sx={{ borderBottom: '1px dashed #fff', py: 1 }}>
                                    <Typography variant='h6' sx={{ fontSize: '13px', color: '#ddd' }}>Address</Typography>
                                    <Typography variant='h4' sx={{ fontSize: '16px', color: '#fff', mt: 1 }}>20, Bardeshi, Dhaka</Typography>
                                </Box>
                                <Box sx={{ borderBottom: '1px dashed #fff', py: 1 }}>
                                    <Typography variant='h6' sx={{ fontSize: '13px', color: '#ddd' }}>Nationality</Typography>
                                    <Typography variant='h4' sx={{ fontSize: '16px', color: '#fff', mt: 1 }}>Bangladeshi</Typography>
                                </Box>
                            </Box>


                        </Box>


                    </Box>

                </Grid>



                <Grid item xs={12} md={6}>
                    <Box sx={{ rowGap: 4 }}>
                        <Typography variant='h6' sx={{ color: 'primary.main', fontWeight: 'bold', fontSize: '21px' }}>About Me</Typography>
                        <Typography variant='h4' sx={{ fontSize: { xs: '20px', sm: '30px', md: '47px' }, fontWeight: '700', my: 3 }}>World Leading <Typography variant='body' color='primary'> Full Stack</Typography> Web Developer</Typography>
                        <Typography variant='h6' sx={{ fontSize: { xs: '18px', sm: '21px' } }}>A passionate Web Developer based In Bangladesh.</Typography>
                        <Typography variant='h6' sx={{ color: 'muted.main', fontSize: { xs: '16px', sm: '18px' }, mt: 3 }}>Hi! My name is Sakib Ahmed Saron. I am Full Stack Web Developer, and I'm very passionate and dedicated to my work. With 6 years experience as a professional Web Developer, I have acquired the skills and knowledge necessary to make your project a success.</Typography>
                        <MyButton sx={{ mt: 5, fontSize: '20px' }}>Download CV</MyButton>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default About;